export default {
  text: 'Dieses Restaurant ist gesperrt. Bitte kontaktieren Sie Ihre Kontaktperson oder senden Sie uns eine Nachricht an <a>{{supportEmail}}</a>, wenn Sie es wiederherstellen möchten.',
};
